import { restRequest } from 'core/utils/backend-service';
import { TenantUsersList } from 'modules/settings/pods/settings-user-location-assignment/settings-user-location-assignment.vm';
import { TenantUsersApiResponse } from './tenant-users.api';
import { TENANT_USERS_ENDPOINT } from './tenant-users.constants';
import { mapTenantUsersFromApiToVm } from './tenant-users.mapper';

export const getTenantUsers = (): Promise<TenantUsersList> =>
    restRequest('GET', TENANT_USERS_ENDPOINT)
        .then((response) => response.json() as Promise<TenantUsersApiResponse>)
        .then(mapTenantUsersFromApiToVm);
